import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const InterestRepartitionPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default InterestRepartitionPage